/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/ostersjopirat/"

const ostersjopirat: CommunityData = {
  code: "ostersjopirat",
  inviteCode: "ostersjopirat",
  name: "Östersjö Pirat",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/osp-621`,
  socials: {},
  styles: {
    global: {
      werzLogoColor: "#FFF",
      counterColor: "#FFF",
      logo: {
        src: `${S3_PREFIX}web-logo.png`,
        styles: "w-[140px] h-[144px]",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[140px] h-[144px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "#000000",
      asideStyles: "",
      contentBg: "#000000",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.mp4?type=video`,
      bgMobile: `${S3_PREFIX}web-background.mp4?type=video`,
      mainFont: "font-['Stencil8bitRegular']",
      primaryButton:
        "bg-[#00ff00] border-2 border-[#00ff00] px-[18px] py-[18px] !text-[#000000] font-['8-bitHUDRegular'] !text-[10px] text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "border-r-[1px] border-[#00ff00]",
      separator: "border-[#00ff00]",
      item: "font-['8-bitHUDRegular'] text-[8px] text-[#FFF] text-opacity-50 leading-[100%] gap-x-[10px] text-center border-b border-[#00ff00] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#000000] !pb-8",
      titles: "text-[#00ff00] font-['8-bitHUDRegular'] text-[18px] text-left leading-[100%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#ffffff] font-['Stencil8bitRegular'] text-[18px] text-left leading-[100%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#00ff00]",
        sectionTitle:
          "text-[#00ff00] font-['8-bitHUDRegular'] text-[18px] text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] h-[326px] overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#00ff00] font-['Stencil8bitRegular'] text-[18px] text-left leading-[100%]",
          subtitle:
            "text-[#ffffff] font-['Stencil8bitRegular'] text-[16px] text-left leading-[100%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#00ff00]",
        sectionTitle:
          "text-[#00ff00] font-['8-bitHUDRegular'] text-[18px] text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-0 sm:!px-4 py-4 sm:!py-0 bg-transparent",
          title: "text-[#00ff00] font-['Stencil8bitRegular'] text-[18px] text-left leading-[100%]",
          subtitle:
            "text-[#ffffff] font-['Stencil8bitRegular'] text-[16px] text-left leading-[100%] mt-2",
          location:
            "text-[#ffffff] font-['Stencil8bitRegular'] text-[16px] text-left leading-[100%] mt-1",
          date: "text-[#ffffff] font-['Stencil8bitRegular'] text-[16px] text-left leading-[100%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#00ff00] font-['Stencil8bitRegular'] text-[24px] text-left leading-[100%]",
        text: "text-[#ffffff] font-['Stencil8bitRegular'] text-[20px] text-left leading-[100%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#00ff00] font-['8-bitHUDRegular'] text-[18px] text-left leading-[100%] !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#000000] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#00ff00]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title: "text-[#00ff00] font-['Stencil8bitRegular'] text-[28px] text-left leading-[100%]",
        subtitle:
          "text-[#ffffff] font-['Stencil8bitRegular'] text-[18px] text-left leading-[100%] mb-4 mt-2",
        button:
          "bg-[#00ff00] border-2 border-[#00ff00] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#000000] font-['8-bitHUDRegular'] !text-[10px] text-left leading-[100%]",
        questions: "text-[18px] text-left leading-[100%] text-[#ffffff]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#00ff00]",
        header: "text-[#00ff00] font-['Stencil8bitRegular'] text-[24px] text-left leading-[100%]",
        text: "text-[#ffffff] font-['Stencil8bitRegular'] text-[18px] text-left leading-[100%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#00ff00]",
        header: "text-[#00ff00] font-['Stencil8bitRegular'] text-[24px] text-left leading-[100%]",
        text: "text-[#ffffff] font-['Stencil8bitRegular'] text-[18px] text-left leading-[100%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden border border-[#00ff00] gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#ffffff00",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#00ff00] font-['Stencil8bitRegular'] text-[24px] text-left leading-[100%]",
        text: "text-[#ffffff] font-['Stencil8bitRegular'] text-[18px] text-left leading-[100%]",
      },
      tickets: {
        header:
          "text-[#00ff00] font-['Stencil8bitRegular'] text-[24px] text-left leading-[100%] px-4 sm:px-8 pt-4 sm:pt-8 mb-4 sm:mb-6 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#000000] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#000000] border-2 border-[#00ff00] px-3 py-3 text-[#ffffff] font-['8-bitHUDRegular'] text-[8px] text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#ffffff00] border-b border-[#00ff00] py-2 sm:py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#00ff00] font-['Stencil8bitRegular'] text-[18px] text-left leading-[100%] mb-1",
          description:
            "text-[#ffffff] font-['Stencil8bitRegular'] text-[18px] text-left leading-[100%] mb-1 flex flex-row",
          price: "text-[#ffffff] font-['Stencil8bitRegular'] text-[18px] text-left leading-[100%]",
          quantity: "text-[#ffffff] font-['8-bitHUDRegular'] text-[8px] text-left leading-[100%]",
          status: "text-[#ffffff] font-['Stencil8bitRegular'] text-[18px] text-left leading-[100%]",
          counterContainer: "bg-[#000000] border-2 border-[#00ff00] px-3 py-3 gap-x-4 !w-fit !h-10",
          button:
            "bg-[#000000] border-2 border-[#00ff00] px-3 py-3 text-[#ffffff] font-['8-bitHUDRegular'] text-[8px] text-left leading-[100%] !w-fit",
          plusMinusColor: "#ffffff",
        },
      },
    },
  },
}

export default ostersjopirat
